var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"position-button",attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{attrs:{"color":"#000","size":"18px"}},[_vm._v(" mdi-close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }